/* Wellnessanar Trustoo widget overrides
 * - Translate widget labels to Mongolian (keep "X Star" English per merchant request)
 * - Hide the per-review timestamp ("X minutes ago")
 * - Inject "🇰🇷 Солонгосоос орчуулсан" badge under "Verified purchase" on each card
 *
 * Strategy: MutationObserver-driven so it works even after Trustoo re-renders
 * (sort change, pagination, lazy load, infinite scroll).
 */
(function () {
  'use strict';

  var T = {
    customer_reviews: 'Хэрэглэгчийн үнэлгээ',
    verified_purchase: 'Баталгаажсан худалдан авалт',
    write_a_review: 'Үнэлгээ үлдээх',
    show_full_review: 'Бүтнээр харах',
    helpful: 'Хэрэгтэй',
    sort_by: 'Эрэмблэх',
    most_recent: 'Хамгийн сүүлд',
    featured: 'Онцлох',
    photo_first: 'Зурагтай эхэндээ',
    highest_rating: 'Хамгийн өндөр үнэлгээ',
    lowest_rating: 'Хамгийн доод үнэлгээ',
    most_helpful: 'Хамгийн хэрэгтэй',
    review_one_singular: ' үнэлгээ',
    review_one_plural: ' үнэлгээ',
    no_reviews: 'Үнэлгээ хараахан байхгүй байна.',
    add_photo: 'Зураг нэмэх',
    submit_review: 'Илгээх',
    your_name: 'Таны нэр',
    your_email: 'Таны имэйл',
    share_feedback: 'Сэтгэгдэл бичих',
    badge_text: 'Солонгосоос орчуулсан',
  };

  // Korean flag SVG (taegeuk-only — recognizable, renders consistently across devices)
  var KR_FLAG_SVG =
    '<svg class="wn-tb-flag" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<rect width="30" height="20" fill="#fff" rx="2"/>'
    + '<defs>'
    + '<clipPath id="wn-tb-cc"><rect width="30" height="20" rx="2"/></clipPath>'
    + '</defs>'
    + '<g clip-path="url(#wn-tb-cc)">'
    + '<path d="M9.5 10 a5.5 5.5 0 0 1 11 0 a2.75 2.75 0 0 0 -5.5 0 a2.75 2.75 0 0 1 -5.5 0z" fill="#cd2e3a"/>'
    + '<path d="M9.5 10 a5.5 5.5 0 0 0 11 0 a2.75 2.75 0 0 1 -5.5 0 a2.75 2.75 0 0 0 -5.5 0z" fill="#0047a0"/>'
    + '</g>'
    + '</svg>';

  function setText(el, txt) {
    if (!el) return;
    if (el.dataset.wnTranslated === '1') return;
    el.textContent = txt;
    el.dataset.wnTranslated = '1';
  }

  function translateOnce(root) {
    root = root || document;

    // "Customer Reviews" header
    root.querySelectorAll('.tt-head-title').forEach(function (el) {
      setText(el, T.customer_reviews);
    });

    // "X reviews" count line — preserve number, change suffix
    root.querySelectorAll('.reviews-num').forEach(function (el) {
      if (el.dataset.wnTranslated === '1') return;
      var raw = (el.textContent || '').trim();
      var m = raw.match(/(\d[\d,]*)/);
      var n = m ? m[1] : raw;
      el.textContent = n + T.review_one_singular;
      el.dataset.wnTranslated = '1';
    });

    // "Verified purchase" badge label
    root.querySelectorAll('.verified-text').forEach(function (el) {
      setText(el, T.verified_purchase);
    });

    // "Show full review" expand link — keep ellipsis prefix if present
    root.querySelectorAll('.display-text').forEach(function (el) {
      if (el.dataset.wnTranslated === '1') return;
      el.textContent = '...' + T.show_full_review;
      el.dataset.wnTranslated = '1';
    });

    // "Write a review" button — fuzzy match because class name varies
    Array.prototype.forEach.call(
      root.querySelectorAll('.tt-write-review, .write-review-btn, .vstar-write-btn, .tt-head-right a, .tt-head-right button, .tt-head-right .button, [class*="write-review"]'),
      function (el) {
        if (el.dataset.wnTranslated === '1') return;
        var t = (el.textContent || '').trim();
        if (/write\s*a?\s*review/i.test(t)) {
          el.textContent = T.write_a_review;
          el.dataset.wnTranslated = '1';
        }
      }
    );

    // Sort by + sort options (heuristic — match exact English strings)
    var sortMap = {
      'Sort by': T.sort_by,
      'Featured': T.featured,
      'Newest': T.most_recent,
      'Most Recent': T.most_recent,
      'Photo priority': T.photo_first,
      'Photo first': T.photo_first,
      'Photo First': T.photo_first,
      'Rating: high to low': T.highest_rating,
      'Rating: low to high': T.lowest_rating,
      'Highest Rating': T.highest_rating,
      'Lowest Rating': T.lowest_rating,
      'Most Helpful': T.most_helpful,
      'Helpful': T.helpful,
    };
    root.querySelectorAll('.tt-head-right *, .sort-by, .sort-by *, .vstar-sort, .vstar-sort *').forEach(function (el) {
      if (el.children.length > 0) return; // only leaf text nodes
      if (el.dataset.wnTranslated === '1') return;
      var t = (el.textContent || '').trim();
      if (sortMap[t]) {
        el.textContent = sortMap[t];
        el.dataset.wnTranslated = '1';
      }
    });

    // Strip leftover translation footer + meaningless option-prefix from review body
    // (defense in depth — bulk migration also strips at source)
    function cleanBodyText(raw) {
      return raw
        // "Сонголт: -->" / "옵션: -->" prefix from translated Korean reviews
        .replace(/^\s*(Сонголт|옵션|Option)\s*:\s*-+>\s*/i, '')
        .replace(/\n\s*(Сонголт|옵션|Option)\s*:\s*-+>\s*/gi, '\n')
        // Wellnessanar editor footer
        .replace(/\n[─—\-]{6,}[\s\S]*$/m, '')
        .replace(/\n*📌\s*Энэ үнэлгээ нь[\s\S]*$/m, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    }
    root.querySelectorAll('.list-review .reviews-text').forEach(function (el) {
      if (el.dataset.wnFooterStripped === '1') return;
      var raw = el.textContent || '';
      var stripped = cleanBodyText(raw);
      if (stripped !== raw) el.textContent = stripped;
      el.dataset.wnFooterStripped = '1';
    });
    root.querySelectorAll('.list-review .remain-text').forEach(function (el) {
      if (el.dataset.wnFooterStripped === '1') return;
      var raw = el.textContent || '';
      var stripped = cleanBodyText(raw);
      if (stripped !== raw) el.textContent = stripped;
      el.dataset.wnFooterStripped = '1';
    });

    // Add badge to each review card under "Verified purchase"
    root.querySelectorAll('.list-review .user-verified').forEach(function (verified) {
      if (verified.dataset.wnBadged === '1') return;
      // Avoid duplicate insertion on subsequent passes
      if (verified.parentElement && verified.parentElement.querySelector('.wn-translated-badge')) {
        verified.dataset.wnBadged = '1';
        return;
      }
      var badge = document.createElement('div');
      badge.className = 'wn-translated-badge';
      badge.innerHTML = KR_FLAG_SVG + '<span class="wn-tb-text">' + T.badge_text + '</span>';
      // Insert as next sibling of .user-verified inside the same <div>
      verified.parentNode.insertBefore(badge, verified.nextSibling);
      verified.dataset.wnBadged = '1';
    });
  }

  function injectStyles() {
    if (document.getElementById('wn-trustoo-overrides-css')) return;
    var css = ''
      // (CLS reservation moved to inline <style> in theme.liquid head — large min-height there)

      // Hide per-review timestamp
      + '.list-review .reviews-date{display:none !important;}'

      // Hide Judge.me widget on every page (we migrated to Trustoo)
      + '.jdgm-widget,'
      + '#judgeme_product_reviews,'
      + '.jdgm-prev-badge,'
      + '.jdgm-rev-widg,'
      + '.jdgm-rev-widg__header,'
      + '.jdgm-row-stars,'
      + '.jdgm-rev-widg__title,'
      + '.jdgm-write-rev-link,'
      + '.jdgm-write-review-modal,'
      + '[id*="judge_me_reviews"],'
      + '[id^="shopify-block"][id*="judge_me"],'
      + '[class*="jdgm-"]'
      + '{display:none !important;visibility:hidden !important;height:0 !important;overflow:hidden !important;}'

      // Translation badge — refined design
      + '.wn-translated-badge{'
        + 'display:inline-flex;align-items:center;gap:5px;'
        + 'margin-top:5px;padding:3px 8px 3px 4px;'
        + 'background:#f5f7fa;'
        + 'color:#4a5568;'
        + 'font-size:11px;line-height:1.3;font-weight:500;'
        + 'border:1px solid #e2e8f0;border-radius:11px;'
        + 'width:fit-content;letter-spacing:0.1px;'
      + '}'
      + '.wn-translated-badge .wn-tb-flag{'
        + 'width:16px;height:11px;flex-shrink:0;'
        + 'border-radius:2px;display:block;'
        + 'box-shadow:0 0 0 1px rgba(0,0,0,0.06);'
      + '}'
      + '.wn-translated-badge .wn-tb-text{white-space:nowrap;}'
      ;
    var style = document.createElement('style');
    style.id = 'wn-trustoo-overrides-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function forceNewestSort() {
    // Trustoo's default is "comprehensive-descending" which doesn't put recent reviews first.
    // Once the widget renders, click the "commented-at-descending" sort option to flip the
    // default to true chronological order.
    //
    // Trustoo's click handler calls scrollIntoView on the widget, hijacking page load
    // to jump down to the reviews section. We prevent that by capturing scroll position
    // before the click and restoring it for several ticks after.
    if (window.__wnNewestSorted) return;
    var newestItem = document.querySelector('.sort-item[sort-value="commented-at-descending"]');
    if (!newestItem) return;
    if (newestItem.classList.contains('active')) {
      window.__wnNewestSorted = true;
      return;
    }
    window.__wnNewestSorted = true;

    var savedY = window.scrollY;
    var savedX = window.scrollX;

    // Monkey-patch Element.scrollIntoView so Trustoo's sort handler can not
    // hijack the page scroll. Restore as soon as the user scrolls or after 3s.
    var origScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () { /* no-op */ };

    var stopped = false;
    function stop() {
      if (stopped) return;
      stopped = true;
      Element.prototype.scrollIntoView = origScrollIntoView;
      window.removeEventListener('wheel', stop, true);
      window.removeEventListener('touchstart', stop, true);
      window.removeEventListener('keydown', onKey, true);
    }
    function onKey(e) {
      // Arrow / page keys count as user scroll
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'PageDown' ||
          e.key === 'PageUp' || e.key === 'Home' || e.key === 'End' || e.key === ' ') {
        stop();
      }
    }
    window.addEventListener('wheel', stop, { capture: true, passive: true });
    window.addEventListener('touchstart', stop, { capture: true, passive: true });
    window.addEventListener('keydown', onKey, true);

    try {
      newestItem.click();
    } catch (e) { /* swallow */ }

    // Active scroll restore via rAF — only while user has not started scrolling
    var deadline = Date.now() + 3000;
    function restore() {
      if (stopped) return;
      if (window.scrollY !== savedY || window.scrollX !== savedX) {
        window.scrollTo(savedX, savedY);
      }
      if (Date.now() < deadline) {
        requestAnimationFrame(restore);
      } else {
        stop();
      }
    }
    requestAnimationFrame(restore);
  }

  function setupLazyTrustoo() {
    // Lazy-load Trustoo widget: keep it hidden until user scrolls near it.
    // This eliminates CLS because the widget's layout shifts happen only AFTER user has scrolled
    // (outside the input-stability window that Lighthouse/Core Web Vitals measure).
    var wrapper = document.getElementById('trustoo-widget-wrapper');
    if (!wrapper) return;
    if (wrapper.dataset.wnLazyArmed === '1') return;
    wrapper.dataset.wnLazyArmed = '1';

    // The widget is hidden via head CSS (display:none on [data-wn-revealed] absent).
    // When user scrolls near it, set data-wn-revealed="1" — CSS rule deactivates,
    // widget reveals with whatever height Trustoo already rendered into it.
    // This shift counts as user-initiated (post-scroll), so it does not impact CLS.
    if (typeof IntersectionObserver === 'undefined') {
      wrapper.setAttribute('data-wn-revealed', '1');
      return;
    }

    // Tracker placed BEFORE the widget so we observe the position, not the hidden widget itself
    var tracker = document.createElement('div');
    tracker.id = 'wn-trustoo-tracker';
    tracker.style.cssText = 'height:1px;width:100%;';
    wrapper.parentNode.insertBefore(tracker, wrapper);

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          wrapper.setAttribute('data-wn-revealed', '1');
          io.disconnect();
          break;
        }
      }
    }, { rootMargin: '800px 0px' });
    io.observe(tracker);
  }

  function init() {
    injectStyles();
    translateOnce(document);
    forceNewestSort();
    setupLazyTrustoo();

    // Re-run on Trustoo re-renders
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Coalesce bursts of mutations (sort change, pagination repaint)
      window.requestAnimationFrame(function () {
        try { translateOnce(document); } catch (e) { /* swallow */ }
        try { forceNewestSort(); } catch (e) { /* swallow */ }
        pending = false;
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
